import * as React from "react";
import { useTranslation } from "react-i18next";
import ReactECharts from "echarts-for-react";


export default function MeteringChart({ data, periods, timeAggType }) {
	const { t } = useTranslation();

	const series = data ? Object.entries(data).map(
		([k, v]) => ({
			name: k,
			data: v,
			type: "bar",
			stack: "x"
		})
	) : []

	const timestamps = periods?.map(p => {
		if (timeAggType == "y")
			return p.split("-")[0]
		if (["m", "q"].includes(timeAggType))
			return p.split("-").slice(0, 2).join("-")
		if (timeAggType === "d")
			return (new Date(p)).toLocaleDateString(undefined, {})
		else
			return (new Date(p)).toLocaleString(undefined, {})
	}) ?? [];

	const options = {
		grid: {
			top: "5%",
			right: 0,
			left: 80
		},
		xAxis: {
			data: timestamps
		},
		yAxis: {
			min: 0,
		},
		legend: {
			show: true,
			bottom: 0,
			left: "center",
			type: "scroll",
			itemGap: 20,
		},
		tooltip: {
			trigger: "axis",
			confine: true,
			valueFormatter: (value) =>
				typeof value === "number"
					? value.toLocaleString(navigator.language, {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					})
					: value,
		},
		series: series,
	};


	return (
		<React.Fragment>
			{timestamps.length > 0 && (
				<ReactECharts
					style={{ width: "95%", height: "90%", paddingLeft: "10px" }}
					option={options}
					notMerge={true}
				/>
			)}
		</React.Fragment>
	);
}
